import { inject, Injectable } from '@angular/core';
import { AoNotificationsService } from '@shopware-operations/aorta';
import { TranslateService } from '../i18';

/**
 * Application notification service.
 *
 * Provides simplified notification API with automatic translation.
 * Wraps Aorta notification service for application-specific notifications.
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  #notificationService = inject(AoNotificationsService);
  translateService = inject(TranslateService);

  notifyUpdateRepeatAction(): void {
    this.#notificationService.create({
      variant: 'warning',
      title: this.translateService.translate('COMMON.NOTIFICATION.UPDATE.REPEAT'),
      description: this.translateService.translate('COMMON.NOTIFICATION.UPDATE.MESSAGE.REPEAT')
    });
  }

  notifyUpdateSuccess(message: string): void {
    this.#notificationService.create({
      variant: 'success',
      title: this.translateService.translate('COMMON.NOTIFICATION.UPDATE.SUCCESS'),
      description: this.translateService.translate(message)
    });
  }

  notifyError(title: string, description: string, autoClose?: boolean): void {
    this.#notificationService.create({
      variant: 'error',
      title: this.translateService.translate(title),
      description: this.translateService.translate(description),
      autoClose: autoClose
    });
  }

  notifySuccess(title: string, description: string): void {
    this.#notificationService.create({
      variant: 'success',
      title: this.translateService.translate(title),
      description: this.translateService.translate(description)
    });
  }
}
